export type ThemeMode = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'uppac-theme-mode';
export const THEME_CHANGE_EVENT = 'uppac-theme-mode-change';

const isThemeMode = (value: unknown): value is ThemeMode => value === 'light' || value === 'dark';

export const getStoredThemeMode = (): ThemeMode => {
    if (typeof window === 'undefined') return 'light';
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    return isThemeMode(stored) ? stored : 'light';
};

export const applyThemeMode = (mode: ThemeMode) => {
    if (typeof document === 'undefined') return;
    document.documentElement.setAttribute('data-theme', mode);
    document.body.setAttribute('data-theme', mode);
};

export const setStoredThemeMode = (mode: ThemeMode) => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(THEME_STORAGE_KEY, mode);
    window.dispatchEvent(new CustomEvent<ThemeMode>(THEME_CHANGE_EVENT, { detail: mode }));
};